import Vue from 'vue';

Vue.filter('asNumberFormat', (price) => ( new Intl.NumberFormat('pl-PL').format(price) + ' zł' ))